import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { SchoolProfileItemEntity } from './school-profile-item-entity';
import { SchoolProfileItemEntityList } from './school-profile-item-entity-list';

import type { SchoolProfileSection } from '@modules/types/graphql';

export type Entity = Partial<SchoolProfileSection> | null;

@DecribeEntity('SchoolProfileSectionEntity')
class SchoolProfileSectionEntity extends BaseEntity {
    name: string;

    @RelationList(() => SchoolProfileItemEntityList)
    items: SchoolProfileItemEntity[];

    constructor(schoolProfileSection: Entity) {
        super(schoolProfileSection);

        this.name = schoolProfileSection?.name ?? '';
    }
}

export { SchoolProfileSectionEntity };
